module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-five3.a1086f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-five3.png
// module id = SGah
// module chunks = 0